import { renderCrewPortrait } from './crew-art';
import { crewImgUrl } from './art-png';
const ARCHETYPE_HUE = {
    earner: '38',
    boarder: '0',
    reactor: '210',
    disruptor: '280',
    comeback: '15',
    modifier: '160',
};
export function renderCrewCard(crew, opts) {
    const compact = opts?.compact ? ' crew--compact' : '';
    const hue = ARCHETYPE_HUE[crew.archetype];
    const cost = opts?.cost !== undefined
        ? `<div class="crew-cost ${opts.affordable === false ? 'crew-cost--cant' : ''}">${opts.cost} 🪙</div>`
        : '';
    const sellRefund = Math.floor((crew.cost * 2) / 3);
    const sell = opts?.sellable
        ? `<button class="crew-sell" data-sell-crew="${crew.id}" title="Sell for ${sellRefund}🪙">Sell ${sellRefund}🪙</button>`
        : '';
    const pngUrl = crewImgUrl(crew.id);
    const portraitInner = pngUrl
        ? `<img class="crew-portrait-img" src="${pngUrl}" alt="" loading="lazy" />`
        : `<svg viewBox="0 0 80 80" preserveAspectRatio="xMidYMid meet" aria-hidden="true">${renderCrewPortrait(crew.id)}</svg>`;
    return `<div class="crew${compact}" data-crew-id="${crew.id}" style="--crew-hue:${hue}">
    <div class="crew-portrait${pngUrl ? ' crew-portrait--png' : ' crew-portrait--svg'}">
      ${portraitInner}
    </div>
    <div class="crew-name">${crew.name}</div>
    <div class="crew-archetype">${crew.archetype}</div>
    <div class="crew-desc">${crew.description}</div>
    <div class="crew-flavor">"${crew.flavor}"</div>
    ${cost}
    ${sell}
  </div>`;
}
